import React from 'react';
import ReactDOM from 'react-dom/client'; // Import the client from react-dom
import App from './App';
// import './index.css';
import axios from 'axios';
import 'antd/dist/reset.css';
import 'react-toastify/dist/ReactToastify.css';
import './index.css';
const root = ReactDOM.createRoot(document.getElementById('root')); // Create a root.

root.render(
  // <React.StrictMode>
    <App />
  // </React.StrictMode>
);
